/**
 * Forgot Password Hooks
 *
 * TanStack Query wrappers around the public `/v1/admin/dashboard/auth/forgot-password`
 * and `/confirm-forgot-password` endpoints. These are pre-auth operations, so no
 * token is required and there is nothing to invalidate on success.
 */

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { forgotPassword, confirmForgotPassword } from '@/lib/api';
import type {
  ForgotPasswordRequest,
  ConfirmForgotPasswordRequest,
  MessageResponse,
} from '@/types/auth';

export function useForgotPassword(): UseMutationResult<
  MessageResponse,
  Error,
  ForgotPasswordRequest
> {
  return useMutation({
    mutationFn: (request: ForgotPasswordRequest) => forgotPassword(request),
  });
}

export function useConfirmForgotPassword(): UseMutationResult<
  MessageResponse,
  Error,
  ConfirmForgotPasswordRequest
> {
  return useMutation({
    mutationFn: (request: ConfirmForgotPasswordRequest) => confirmForgotPassword(request),
  });
}
